import { UseQueryResult, useQuery } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { PosRegistration } from "../types/posRegistration.type";

export const usePosGetRegistration: (id?: string) => UseQueryResult<PosRegistration, unknown> = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: PosRegistration; }; }, unknown, PosRegistration>({
    queryKey: ['posGetRegistration', id],
    queryFn: () => privateAxios.get(`/pos/registrations/${id}`),
    enabled: !!id,
    select: (data) => data?.data?.data,
    refetchInterval: 5000,
    retry: false,
  });
};
